function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "security_svg__a",
  x: 23.727,
  y: 18.084,
  width: 39.898,
  height: 45.271,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c",
  floodOpacity: 0.827
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".security_svg__c,.security_svg__d{stroke:#1b1c26;stroke-width:2px}.security_svg__c{fill:#ff6c6c}.security_svg__d,.security_svg__i{fill:none}.security_svg__d{stroke-linecap:round}.security_svg__h{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.571 7.792)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#1b1c26",
  strokeWidth: 2,
  fill: "#383d5a"
}, /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__h",
  width: 28.831,
  height: 45.195,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__i",
  x: 1,
  y: 1,
  width: 26.831,
  height: 43.195,
  rx: 4
})), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__c",
  d: "M14.415 22.481a6.623 6.623 0 016.623 6.623v.433a.736.736 0 01-.736.736H8.528a.736.736 0 01-.736-.736v-.433a6.623 6.623 0 016.623-6.623z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "security_svg__c",
  cx: 3.506,
  cy: 3.506,
  r: 3.506,
  transform: "translate(10.909 15.468)"
}), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__d",
  d: "M1.142 39.551h27.012M1.142 7.603h26.423M13.247 4.208h5.065m-8.182 0h.779"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "#ff6c6c"
}, /*#__PURE__*/React.createElement("path", {
  className: "security_svg__h",
  d: "M44.715 56.052l-1.092-.606-.994.426.002-.932c-1.396-.718-4.596-2.615-7.38-6.058-3.637-4.486-3.534-12.32-3.524-12.807v-6.88l.746-.196 10.16-2.664v-.504l1.031.234 1.051-.263v.533l10.16 2.664.746.195v6.882c.01.484.118 8.318-3.523 12.808-2.787 3.443-5.986 5.338-7.383 6.058v1.11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.715 54.355v-.038c.602-.273 4.406-2.11 7.606-6.064 3.488-4.3 3.3-12.166 3.3-12.166v-6.121l-10.906-2.86v-.023l-.039.01-.043-.01v.023l-10.906 2.86v6.121s-.186 7.865 3.3 12.166c3.198 3.953 7.008 5.793 7.606 6.064v.038l.043-.018.04.018m.038 2.04c-.162 0-.322-.019-.482-.062a2.031 2.031 0 01-.871-.389c-1.328-.66-4.873-2.658-7.928-6.433-1.67-2.06-2.807-4.969-3.379-8.647a30.21 30.21 0 01-.367-4.797v-6.101c0-.91.613-1.703 1.492-1.936l10.623-2.783a2 2 0 01.791-.164h.082c.272 0 .541.057.793.164L55.13 28.03a2.002 2.002 0 011.492 1.936v6.101c.004.27.026 2.28-.365 4.797-.572 3.678-1.709 6.586-3.383 8.649-2.947 3.642-6.351 5.629-7.779 6.357a1.845 1.845 0 01-.326.244 2.027 2.027 0 01-1.014.282z",
  fill: "#1b1c26"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.001 .002)",
  filter: "url(#security_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.677 54.342l-.043.018v-.037a22.577 22.577 0 01-7.605-6.064c-3.486-4.3-3.3-12.166-3.3-12.166v-6.121l10.906-2.859v-.023l.043.01.039-.01v.023l10.906 2.859v6.118s.188 7.865-3.3 12.166a22.586 22.586 0 01-7.605 6.064v.037z",
  fill: "#ff6c6c"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.181 33.506)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__c",
  width: 6.234,
  height: 8.909,
  rx: 3.117,
  transform: "translate(2.338)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 3.896)",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "#ff6c6c",
  stroke: "#1b1c26",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__h",
  width: 10.909,
  height: 8.792,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__i",
  x: 1,
  y: 1,
  width: 8.909,
  height: 6.792,
  rx: 1
})), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__d",
  d: "M5.455 8.694v-1"
}));

var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.625,
    height: 63.355
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,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";
export { SvgSecurity as ReactComponent };